// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__3cWJp","legacyBtn":"MutateMid_legacyBtn__3e4Qc"};